import React, { Component, ErrorInfo, ReactNode } from 'react';
import { ErrorState } from '../../Layout/ErrorState';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ChatErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Chat error boundary caught an error:', error, errorInfo);
    
    // Analytics/Monitoring
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'chat_error', {
        error_type: 'component_error',
        error_message: error.message,
        error_stack: error.stack,
      });
    }
  }

  private handleRetry = () => {
    this.setState({ hasError: false, error: undefined });
  };

  public render() {
    if (this.state.hasError) {
      return this.props.fallback || (
        <div className="app-error-state-section">
          <ErrorState
            eyebrow="Chat view"
            title="This chat view stopped rendering"
            message="Your conversation is not deleted. Try reopening the view, or refresh if the issue keeps happening."
            primaryAction={{ label: 'Try again', onClick: this.handleRetry }}
            secondaryAction={{ label: 'Refresh page', onClick: () => window.location.reload() }}
            error={this.state.error}
          />
        </div>
      );
    }

    return this.props.children;
  }
}
